import { Collapse, Tooltip, Typography } from "antd"
import cls from "classname"
import { NavLink } from "react-router-dom"

import { FEATURE_FLAGS } from "../../constants/feature-flags"
import { RoutesPaths } from "../../constants/user-routes"
import Icon from "../../Icon"
import ArrowSelectDown from "../../Icon/img/ArrowSelectDown"
import ArrowSelectDownMobile from "../../Icon/img/ArrowSelectDownMobile"
import { buildTestId } from "../../Utils/testId"
import GettingStartedProgressIcon from "../GettingStartedPage/componets/GettingStartedProgressIcon"

import "./styles.less"

const { Panel } = Collapse
const { Text } = Typography

export const NavLinkWithIcon = ({
  url,
  withoutUrl,
  iconType,
  text,
  active,
  theme,
  isOpened,
  isSoon,
  isNotClickable,
  markText,
  markTextBordered,
  openSidebar,
  location,
  isDropdown,
  options,
  activeKey,
  setActiveKey,
  flag,
  t,
  isSetting = false,
  isMobile = false,
  isNew = false,
  isCustomAction,
  onClick,
  siderBarStatistics,
  tourGuideId,
  iconNode,
  testId,
  ...props
}) => {
  const mouseOver = (e) => {
    let target = e.target
    const { scrollWidth, clientWidth } = target
    if (scrollWidth > clientWidth) target.classList.add("overflowing")
  }

  const mouseLeave = (e) => {
    let target = e.target
    target.classList.remove("overflowing")
  }

  return isDropdown && isOpened ? (
    <CollapsibleNavLink
      url={url}
      iconType={iconType}
      iconStyle={props?.style}
      text={text}
      active={active}
      theme={theme}
      isOpened={isOpened}
      isSoon={isSoon}
      markTextBordered={markTextBordered}
      openSidebar={openSidebar}
      location={location}
      options={options}
      activeKey={activeKey}
      setActiveKey={setActiveKey}
      flag={flag}
      t={t}
      isNew={isNew}
      siderBarStatistics={siderBarStatistics}
      isNotClickable={isNotClickable}
      tourGuideId={tourGuideId}
      isMobile={isMobile}
      testId={testId}
    />
  ) : (
    <OptionalLink
      to={url}
      withoutUrl={withoutUrl}
      tourGuideId={tourGuideId}
      testId={testId}
      onClick={(e) => {
        setActiveKey([])
        if (isCustomAction && onClick) {
          e.preventDefault()
          e.stopPropagation()
          onClick()
          return e
        }
        if (isSoon || isNotClickable) {
          return e.preventDefault()
        } else {
          if (openSidebar) openSidebar()
          return e
        }
      }}
      className={cls("sidebar-link", {
        disabled: isSoon || isNotClickable,
        withoutUrl: withoutUrl
        // selected:
        // (url === '/sales-tracker/stores' && location?.includes('sales-tracker')) ||
        // (url === '/setting/account' && location?.includes('setting')) ||
        // (url === '/shop-finder/overview' && location === '/shop-finder/overview') ||
        // (url === '/shop-finder/collections' && location === '/shop-finder/collections'),
      })}
    >
      {iconNode ? (
        <>{iconNode}</>
      ) : (
        <Icon
          className="sidebar-link_icon"
          type={iconType}
          role="icon"
          outline={active}
          theme={theme}
          {...props}
        />
      )}
      {isOpened ? (
        <>
          {markText ? (
            <span
              className={cls("sidebar-link_mark", {
                "mark-text-bordered": markTextBordered
              })}
            >
              {markText}
            </span>
          ) : null}

          <span
            data-text={text}
            onMouseOver={mouseOver}
            onMouseLeave={mouseLeave}
            className={cls("sidebar-link-text", {
              setting: isSetting,
              disabled: isSoon || isNotClickable
            })}
          >
            {text}
            {isSetting && isMobile ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M8.33398 13.3337L11.0781 10.5896C11.4035 10.2641 11.4035 9.73651 11.0781 9.41107L8.33398 6.66699"
                  stroke="#707BA0"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : null}
            {/* {isNew ? <span className="dashboard-page-block-title-tag">new</span> : null} */}
          </span>
        </>
      ) : null}
    </OptionalLink>
  )
}

const CollapsibleNavLink = ({
  url,
  tourGuideId,
  iconType,
  iconStyle,
  text,
  active,
  theme,
  isOpened,
  isSoon,
  markTextBordered,
  openSidebar,
  location,
  options,
  activeKey,
  setActiveKey,
  flag,
  t,
  isNew,
  siderBarStatistics,
  isNotClickable,
  isMobile = false,
  testId
}) => {
  const handleHeaderClick = (e) => {
    if (isNotClickable) {
      e.stopPropagation()
      e.preventDefault()
      return
    }
    setActiveKey(activeKey.includes(flag) ? [] : [flag])
    if (isSoon) {
      e.preventDefault()
    }
  }

  const isDropdownOpen = activeKey.includes(flag)

  return (
    <Collapse collapsible={"header"} ghost={true} activeKey={activeKey}>
      <Panel
        key={flag}
        showArrow={false}
        header={
          <NavLink
            to={url}
            onClick={handleHeaderClick}
            data-tour={tourGuideId}
            data-testid={testId}
            className={cls("sidebar-link sidebar-dropdown-link-main", {
              disabled: isSoon || isNotClickable,
              rotated: isDropdownOpen
            })}
          >
            <Icon
              className="sidebar-link_icon"
              type={iconType}
              role="icon"
              outline={active}
              theme={theme}
              style={iconStyle}
            />
            {isOpened ? (
              <span
                className={cls("sidebar-link-text", {
                  disabled: isSoon || isNotClickable
                })}
              >
                {text}
                {isNew && (
                  <span className="dashboard-page-block-title-tag dropdown">{t("new")}</span>
                )}
                <span className="sidebar-link-arrow">
                  {!isMobile ? <ArrowSelectDown /> : <ArrowSelectDownMobile />}
                </span>
              </span>
            ) : null}
          </NavLink>
        }
      >
        {options.map((el) => {
          // `activePaths` lets an option stay highlighted on sibling routes it
          // doesn't navigate to (e.g. Configure links to /profile but must also
          // light up on /business). Unset → behaves exactly as before.
          const matchesActivePath =
            el?.activePaths?.some((p) => location === p || location.startsWith(`${p}/`)) ?? false
          const activeLink = location === el?.url || matchesActivePath
          const optionIsDisabled = el?.isSoon || el?.isDisabled

          const option = (
            <NavLink
              to={el?.url}
              key={el?.url}
              data-tour={el?.tourGuideId}
              data-testid={buildTestId("sidebar-item", flag || text, el?.text)}
              onClick={(e) => {
                if (optionIsDisabled) {
                  return e.preventDefault()
                } else {
                  if (openSidebar) openSidebar()
                  return e
                }
              }}
              className={({ isActive }) =>
                cls("sidebar-link sidebar-dropdown-link", {
                  disabled: optionIsDisabled,
                  active: isActive || matchesActivePath
                })
              }
            >
              <>
                {el?.markText ? (
                  <span
                    className={cls("sidebar-link_mark", {
                      "mark-text-bordered": markTextBordered
                    })}
                  >
                    {t(el?.markText)}
                  </span>
                ) : null}
                <span
                  className={cls("sidebar-link-text", {
                    disabled: optionIsDisabled
                  })}
                >
                  {el?.text}
                </span>

                {el?.statKey && (
                  <Text type={!activeLink && "secondary"}>{siderBarStatistics?.[el.statKey]}</Text>
                )}
              </>
            </NavLink>
          )

          return optionIsDisabled && el?.disabledTooltip ? (
            <Tooltip
              placement="right"
              title={t(el.disabledTooltip)}
              key={el?.url}
              overlayClassName="sidebar-tooltip"
            >
              {option}
            </Tooltip>
          ) : (
            option
          )
        })}
      </Panel>
    </Collapse>
  )
}

function OptionalLink({ to, tourGuideId, testId, withoutUrl, children, ...props }) {
  if (withoutUrl) {
    return (
      <span data-tour={tourGuideId} data-testid={testId} {...props}>
        {children}
      </span>
    )
  }
  return (
    <NavLink data-tour={tourGuideId} data-testid={testId} to={to} {...props}>
      {children}
    </NavLink>
  )
}

const matchesPath = (pathname, url) => !!url && (pathname === url || pathname.startsWith(`${url}/`))

// Which dropdown owns an address. A group only ever opened on a click of its own
// header, so a page reached by URL — typed, bookmarked or landed on through a
// redirect — left its group collapsed (CHA1-3116).
//
// Scored by the length of the address that matched, so a group whose option is a
// prefix of another group's never wins over the deeper one just by sitting
// earlier in the menu.
export const getDropdownFlagForPath = (entries, pathname) =>
  entries
    ?.flatMap((entry) => entry?.items ?? [entry])
    ?.reduce(
      (best, item) => {
        if (!item?.dropdown) return best

        const score = [...(item.options ?? [])]
          .flatMap((option) => [option?.url, ...(option?.activePaths ?? [])])
          .filter((url) => matchesPath(pathname, url))
          .reduce((longest, url) => Math.max(longest, url.length), 0)

        return score > best.score ? { flag: item.flag, score } : best
      },
      { flag: undefined, score: 0 }
    )?.flag

// Sidebar layout (CHA1-2847): Home plus four product-line groups. A group is a
// non-clickable label followed by its items; `items` is what the renderer walks.
// Everything outside a group (Getting Started, Home) is a bare item.
export const navIconsArr = {
  desktop: [
    {
      url: "/getting_started",
      iconDesk: "homesidebar",
      iconNode: <GettingStartedProgressIcon />,
      text: "Getting Started"
    },
    {
      url: RoutesPaths.home,
      iconDesk: "homesidebar",
      text: "Home",
      tourGuideId: "home-nav"
    },
    {
      group: "PREVENT",
      items: [
        {
          url: RoutesPaths.alerts.all,
          iconDesk: "alerts",
          text: "Alerts",
          flag: "alerts",
          markTextBordered: true,
          dropdown: true,
          tourGuideId: "alerts-nav",
          options: [
            { text: "All", url: RoutesPaths.alerts.all, key: "general", statKey: "alerts" },
            {
              text: "Credits",
              url: RoutesPaths.credits,
              markText: null,
              statKey: "credits"
            },
            {
              text: "Configure",
              url: RoutesPaths.configure.root,
              // Integrations moved in as the Integrate tab, so Configure has to
              // stay lit on every /configure/* slug.
              activePaths: [RoutesPaths.configure.root],
              markText: null,
              tourGuideId: "configure-nav"
            }
          ]
        },
        {
          url: RoutesPaths.dashboard.root,
          iconDesk: "analytics",
          text: "Analytics",
          // Three items are called "Analytics"; the collapsed rail tells them
          // apart by tooltip alone.
          tooltipText: "Alerts Analytics",
          tourGuideId: "prevent-analytics-nav"
        }
      ]
    },
    {
      group: "DEFLECT",
      items: [
        {
          url: RoutesPaths.receipts.all,
          // `card` is the glyph the prototype uses for Receipt; it draws at 1em,
          // hence the explicit size to match the fixed-20px sidebar icons.
          iconDesk: "card",
          iconStyle: { fontSize: 20 },
          text: "Receipt",
          flag: "receipts",
          // Locked until the backend opens it per merchant; see `unlockFlag` in Sidebar/index.js.
          unlockFlag: FEATURE_FLAGS.RECEIPTS,
          markTextBordered: true,
          dropdown: true,
          tourGuideId: "receipts-nav",
          options: [
            { text: "All", url: RoutesPaths.receipts.all, key: "general", statKey: "receipts" },
            {
              text: "Configure",
              // Section-less URL so the wizard resumes on the merchant's last
              // incomplete step instead of always dropping them on step 1.
              url: RoutesPaths.receipts.configure_profile,
              // Keep highlighted on every Configure sub-route (Profile wizard steps
              // AND the Business tab), which live under different subpaths.
              activePaths: [RoutesPaths.receipts._configure],
              markText: null,
              tourGuideId: "receipts-configure-nav"
            }
          ]
        },
        {
          url: RoutesPaths.deflect.analytics,
          iconDesk: "analytics",
          text: "Analytics",
          tooltipText: "Deflect Analytics",
          markText: "SOON",
          markTextBordered: true,
          isNotClickable: true
        }
      ]
    },
    {
      group: "HEALTH",
      items: [
        {
          url: RoutesPaths.health.overview,
          iconDesk: "centralhub",
          text: "Status",
          flag: "health",
          markTextBordered: true,
          dropdown: true,
          requireCurBAHighAccessRole: true,
          disabledTooltip: "Available for Owner/Admin roles only",
          options: [
            { text: "Overview", url: RoutesPaths.health.overview, key: "general" },
            { text: "Monitoring", url: RoutesPaths.health.monitoring }
          ]
        }
      ]
    }
    // {
    //   group: "RECOVER",
    //   items: [
    //     {
    //       url: RoutesPaths.recover.disputes,
    //       // Same glyph the prototype uses for Disputes (checklist + bell).
    //       iconDesk: "checklist_bell",
    //       text: "Disputes",
    //       markText: "SOON",
    //       markTextBordered: true,
    //       isNotClickable: true
    //     },
    //     {
    //       url: RoutesPaths.recover.analytics,
    //       iconDesk: "analytics",
    //       text: "Analytics",
    //       tooltipText: "Recover Analytics",
    //       markText: "SOON",
    //       markTextBordered: true,
    //       isNotClickable: true
    //     }
    //   ]
    // }
  ],
  // Support, Help center and Developers left the sidebar in CHA1-2847 —
  // Developers is a Settings section now, the other two have no entry point.
  bottomMenu: []
}

export const navIconsAdmin = [
  // {
  //   url: '/admin/portfolio',
  //   iconDesk: 'portfolio',
  //   text: 'Portfolio',
  // },
  // {
  //   url: '/admin/database',
  //   iconDesk: 'database',
  //   text: 'Database',
  //   comingSoon: true,
  //   markText: 'soon',
  // },
  // {
  //   url: '/admin/droptimes',
  //   iconDesk: 'calendar',
  //   text: 'Drop times',
  // },
  // {
  //   url: '/admin/bd',
  //   iconDesk: 'b_d',
  //   text: 'Benefits & Drawbacks',
  // },
  // {
  //   url: '/admin/shopify',
  //   iconDesk: 'ali_drops',
  //   text: 'Shopify',
  // },
  // {
  //   url: '/admin/store-manager',
  //   iconDesk: 'settings',
  //   text: 'Store manager',
  // },
  // {
  //   url: '/admin/store-table',
  //   iconDesk: 'gps',
  //   text: 'Store table',
  // },
]
